
const INIT_STATE = {
    planModelVisible: false,
    patientInfo: [],
    textMessage: '',
    success: false,
    error: false,
    redirectFromDashboard: false,
    DailyRecord: [],
    PlaneUnSubscribePlane: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case 'reset_unsubscribe': {
            return {
                ...state,
                PlaneUnSubscribePlane: false
            }
        }
        case 'unsubscribePlane_SUCCESS': {
            return {
                ...state,
                PlaneUnSubscribePlane: true
            }

        }

        case 'getDailyOverview_SUCCESS': {
            return {
                ...state,
                DailyRecord: action.payload.Record
            }
        }
        case 'getPatientInfo_SUCCESS': {
            return {
                ...state,
                patientInfo: action.payload.Record
            }
        }
        case 'getPatientInfo_FAILURE': {
            return {
                ...state,
                patientInfo: action.payload.Record,
                textMessage: 'Could not fetch data due to api failure',
                error: true
            }
        }
        case 'reset_patientDashboard': {
            return {
                ...state,
                success: false,
                error: false,
            }
        }

        case 'plan_Modal': {
            return {
                ...state,
                planModelVisible: !state.planModelVisible,
                error: false
            }
        }
        case 'redirectState': {
            return {
                ...state,
                redirectFromDashboard: true
            }
        }

        default: {
            return { ...state }
        }



    }
}